import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { ReadOnlyFormControl } from 'components/common/fields';
import { isP2P, isA2A } from '../consts';

const DeliveryType = ({ transaction }) => {
  const isSupportedType =
    isP2P(transaction.transactionType) || isA2A(transaction.transactionType);
  return isSupportedType ? (
    <Grid item xs={3}>
      <ReadOnlyFormControl
        label="Delivery Type"
        value={transaction.disburseTypeDerived}
      />
    </Grid>
  ) : null;
};

DeliveryType.propTypes = {
  transaction: PropTypes.shape({
    disburseTypeDerived: PropTypes.string,
    transactionType: PropTypes.string,
  }).isRequired,
};

export default DeliveryType;
